import React, { useState, useEffect } from "react";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subYears from "date-fns/subYears";
import addYears from "date-fns/addYears";
import Header from "../../Header/Header";
import foodbrand from "../../assets/foodbrand@2x.png";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import "./flags.css";

registerLocale("es", es);
setDefaultLocale("es");

const LicDate = () => {

  const [isEnabled, setIsEnabled] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const today = new Date();
  const tenYearsAgo = subYears(today, 10);
  const tenYearsFromNow = addYears(today, 10);
  const navigate = useNavigate();

  useEffect(() => {
    let monthStr = "";
    if ((selectedDate.getMonth() + 1) < 10) {
      monthStr = "0" + (selectedDate.getMonth() + 1);
    } else {
      monthStr = "" + (selectedDate.getMonth() + 1);
    }

    /** Validacion para dias */

    let darStr = "";
    if ((selectedDate.getDate()) < 10) {
      darStr = "0" + (selectedDate.getDate());
    } else {
      darStr = "" + (selectedDate.getDate());
    }

    let dateStr = "" + selectedDate.getFullYear() + "-" + (monthStr) + "-" + darStr;
    localStorage.setItem("vigencia", "" + dateStr);
  });

  // const handleCheckboxChange = (event) => {
  //   const target = event.target;
  //   const value = target.type === "checkbox" ? target.checked : target.value;
  //   setIsEnabled(value);
  // };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    localStorage.setItem("vigencia", "" + date);
    setIsEnabled(false);
  };

  const handleDatePickerClose = () => {
    if (selectedDate === null) {
      setIsEnabled(false);
    }
  };

  const getContinue = async () => {

    if (isEnabled === true) {
      localStorage.setItem("vigencia", "PERMANENTE");
    } else {
      let monthStr = "";
      if ((selectedDate.getMonth() + 1) < 10) {
        monthStr = "0" + (selectedDate.getMonth() + 1);
      } else {
        monthStr = "" + (selectedDate.getMonth() + 1);
      }

      /** Validacion para dias */

      let darStr = "";
      if ((selectedDate.getDate()) < 10) {
        darStr = "0" + (selectedDate.getDate());
      } else {
        darStr = "" + (selectedDate.getDate());
      }

      let dateStr = "" + selectedDate.getFullYear() + "-" + (monthStr) + "-" + darStr;
      localStorage.setItem("vigencia", "" + dateStr);
    }

    navigate("/AppIncodeLicencia", {
      state: {
        rutaContinue: "/PantallaBase49Lic",
        typeCredential: "lic"
      }
    });

  };

  const onCheckDateValue = async (event) => {
    if (event.target.checked && !isEnabled) {
      setIsEnabled(true);
    } else if (event.target.checked && isEnabled) {
      setIsEnabled(false);
    }
  }


  return (
    <>
      <div className="initBack_P2 animate__animated animate__fadeIn">
        <Header
          imgBack={true}
          rutaBack="/NumeroLic"
          title="Licencia de Conducir"
          name="LicDate"
        />

        <div className="containerRender">
          <div className="containerInfo_P2">
            <div className="containerIdent_P2">
              <p className="txtNat_Licencia">Vigencia</p>

              <div>
                <DatePicker
                  className="dateStyle"
                  selected={selectedDate}
                  onChange={handleDateChange}
                  onCalendarClose={handleDatePickerClose}
                  dateFormat="yyyy-MM-dd"
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  dropdownMode="select"
                  minDate={tenYearsAgo}
                  maxDate={tenYearsFromNow}
                  disabled={isEnabled}
                  locale="es"
                />
              </div>
              <br />
              <div>
                <div id="left">
                  <div className='containerCheck_P28 spaceRadioLicPer'>
                    <input type="radio" className="rdnSize" checked={isEnabled} onClick={onCheckDateValue} onChange={onCheckDateValue} />
                    <br />
                    <br />
                    <br />
                  </div>
                </div>

                <div id="right">
                  <div id="object3">
                    <div className='permanenteSpaceLic'>
                      Permanente
                    </div>
                  </div>
                  <div id="object4">
                    <div className="subtitleCheck">
                      Seleccione esta opción solo si la vigencia de su licencia de conducir dice permanente.
                    </div>
                  </div>
                </div>
              </div>

              <hr className="line" />
              <button
                className="button_P2 animate__animated animate__fadeIn"
                onClick={getContinue}
              >
                <span className="txtButton_P2">Continuar</span>
              </button>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="imageContainer_P2">
            <img src={foodbrand} className="imgFooter_P2" />
          </div>
        </div>
      </div>
    </>
  );
};

export default LicDate;
